import * as yup from 'yup';
import { message } from './helpers';

export default yup.object().shape({
  name: yup.string().required(message('required', 'Name')),
  file: yup.string().required(message('required', 'File')),
  private: yup.boolean(),
});
